import entityContainerConnector from '~components/generic/entityContainerConnector';
import ResponsiveBackground from '~components/generic/responsive-background/ResponsiveBackground';

export default entityContainerConnector(ResponsiveBackground);
